<template>
  <div class="goodsType">
    <!-- 顶部提示banner -->
    <div class="page-heading" style="background-image: url('static/menhu/images/vantis_fan_bg.jpg')">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1>产品分类</h1>
            <span>梵蒂斯全系列产品快速鉴赏</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 分类列表目录 -->
    <div class="gtDiv">
      <div class="simple-recent-projects projects-page full-screen-projects filter-projects section-gap">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <div class="row masonry-layout filters-content normal-col-gap">
                <div @click.prevent="toGoodsListPage(item.id,item.typename,item.typeimg)" v-for="(item,index) in typeList" :key="index" class="col-lg-6 masonry-item all category-building">
                  <div class="item">
                    <div class="project-item">
                      <div class="thumb">
                        <p class="thumbTitle">{{ item.typename }}</p>
                        <img :src="item.typeimg" alt=""/>
                        <div class="hover">
                          <div class="inner-content">
                            <h4><a href="#">{{ item.typename }}</a></h4>
                            <span>查看系列产品 →</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'goodsType',
  data() {
    return {
      typeList: []
    }
  },
  created() {
    this.getData();
  },
  methods:{
    //查询分类数据
    getData(){
      let _this = this;
      this.$axios.get('/fantis/goodsType/ftCmsGoodsType/list?pageNo=1&pageSize=999')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            let typeList = tempData.records;
            for(let i in typeList){
              if(typeList[i].typeimg.startsWith('//') || typeList[i].typeimg.startsWith('https://') || typeList[i].typeimg.startsWith('http://')){

              }else{
                typeList[i].typeimg = _this.$fileDPath + typeList[i].typeimg;
              }
            }

            _this.typeList = typeList;

          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    // 点击跳转到分类下的产品列表
    toGoodsListPage(typeID,typeName,image){
      this.$router.push({
        name:"goods",
        params:{"typeID":typeID,"typeName":typeName,"typeImage":image}
      });
    }
  }
}
</script>

<style scoped>
.goodsType {

}

.gtDiv {
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  padding: 0px 20px 0px 20px;
}

.thumbTitle {
  position: absolute;
  top: 15%;
  left: 35%;
  font-size: 32px;
  color: #fff;
  font-weight: 700;
  text-shadow: 1px 1px 10px dimgrey;
}

.page-heading {
  margin-bottom: 40px;
  text-align: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  padding: 100px 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/views/goods/goodsType.vue